import { render, staticRenderFns } from "./MainLayout.vue?vue&type=template&id=64f3aeec&scoped=true&"
import script from "./MainLayout.vue?vue&type=script&lang=js&"
export * from "./MainLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64f3aeec",
  null
  
)

export default component.exports